import { useOverlayScale } from "../editor/hooks";

type Props = {
  cx: number;
  cy: number;
  onInsert: () => void;
};

export function VertexInsertionHandle({ cx, cy, onInsert }: Props) {
  const overlayScale = useOverlayScale();

  const onMouseDown = (event: React.MouseEvent<SVGCircleElement>) => {
    event.stopPropagation();
    onInsert();
  };

  const onKeyDown = (event: React.KeyboardEvent<SVGCircleElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.stopPropagation();
      onInsert();
    }
  };

  return (
    <circle
      cx={cx}
      cy={cy}
      r={8 / overlayScale}
      fillOpacity={0.5}
      stroke="transparent"
      strokeWidth={2 / overlayScale}
      className="pointer-events-auto cursor-pointer fill-none hover:fill-brand focus:fill-brand focus:outline-hidden"
      onMouseDown={onMouseDown}
      onKeyDown={onKeyDown}
      tabIndex={0} // Enable receiving keyboard events + focus styles
    />
  );
}
